<template>
  <div class="article-content-meta col-3">
    <button
      :class="{ error: errors.has('coverKey') }"
      class="btn sc-btn sc-btn-outline info mb-3"
      @click="showDialog = 'upload'"
    >
      <input
        v-validate="'required'"
        :value="cover.key"
        type="hidden"
        name="coverKey"
      />
      <img
        src="/static/icons/button-add-cover.svg"
        class="sc-btn-icon"
        width="22"
        height="22"
      />
      <span v-if="!cover.url">{{ $t("button.upload") }}</span>
      <span v-else>{{ canUpdateContent ? "แก้ไข" : "" }}รูปปก</span>
    </button>
    <button
      :class="{ error: errors.has('thumbnailKey') }"
      class="btn sc-btn sc-btn-outline info"
      @click="handleClickUploadThumbnailButton"
    >
      <input :value="thumbnail.key" type="hidden" name="thumbnailKey" />
      <img
        src="/static/icons/button-add-cover.svg"
        class="sc-btn-icon"
        width="22"
        height="22"
      />
      <span v-if="!$isCallCenter && !thumbnail.url">อัปโหลดรูป Thumbnail</span>
      <span v-else>{{ canUpdateContent ? "แก้ไข" : "" }}รูป Thumbnail</span>
    </button>
    <div v-if="settings" class="setting-options">
      <ul class="meta-list">
        <li
          :class="{ edit: settings.file.name }"
          class="meta-item text-truncate"
          @click="showDialog = 'setting.file'"
        >
          <h4>{{ $t("feature.article.setting.file") }}</h4>
          <strong>
            {{ settings.file.name }}
          </strong>
        </li>
        <!-- ซ่อน feature แผนที่เนื่องจาก google qouta -->
        <!--li
          class="meta-item text-truncate"
          :class="isDisabledClass(settings.map.locationName)"
          @click="showDialog = 'setting.map'"
        >
          <h4>{{ $t("feature.article.setting.map") }}</h4>
          <strong>
            {{ settings.map.locationName }}
          </strong>
        </li-->
        <li
          :class="isDisabledClass(settings.album.length > 0)"
          class="meta-item text-truncate"
          @click="showDialog = 'setting.album'"
        >
          <h4>{{ $t("feature.article.setting.album") }}</h4>
          <strong v-show="settings.album.length > 0">
            จำนวน {{ settings.album.length }} รูป
          </strong>
        </li>
      </ul>
    </div>
    <setting
      v-if="getSettingOptionAtPosition(0) === 'setting'"
      :approved-at="articleApprovedAt"
      :data-setting="settings"
      :create-with-tab="getSettingOptionAtPosition(1)"
      :can-edit="canUpdateContent"
      @isshow="isShow"
      @save="saveSetting"
      @setEdit="setEdit()"
    ></setting>
    <upload
      v-if="showDialog === 'upload'"
      :cover-url="cover.url"
      :cover-key="cover.key"
      :can-edit="true"
      @isshow="isShow"
      @save="saveCover"
      @setEdit="setEdit()"
    ></upload>
    <upload-thumbnail
      :is-show="uploadThumbnailDialog.isShow"
      :is-loading="uploadThumbnailDialog.isLoading"
      :thumbnail-file="thumbnail.file"
      :thumbnail-url="thumbnail.url"
      :thumbnail-key="thumbnail.key"
      :can-edit="true"
      @cancel="handleCancelUploadThumbnailDialog"
      @confirm="handleConfirmUploadThumbnailDialog"
    ></upload-thumbnail>
  </div>
</template>

<script>
import axios from "axios"
import Setting from "@/components/admin/view/article/create/Setting"
import Upload from "@/components/helper/dialog/UploadCover"
import UploadThumbnail from "@/components/helper/dialog/UploadThumbnail"

export default {
  components: {
    Setting,
    Upload,
    UploadThumbnail,
  },
  props: {
    dataSettings: {
      type: null,
      default: undefined,
    },
    articleApprovedAt: {
      type: null,
      default: undefined,
    },
    cover: {
      type: null,
      default: undefined,
    },
    canUpdateContent: {
      type: null,
      default: undefined,
    },
    thumbnail: {
      type: null,
      default: undefined,
    },
    isThaiLanguage: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      showDialog: false,
      isEdit: false,
      uploadThumbnailDialog: {
        isShow: false,
        isLoading: false,
      },
    }
  },
  computed: {
    settings() {
      return this.dataSettings
    },
  },
  methods: {
    getSettingOptionAtPosition(position) {
      if (this.showDialog) {
        const value = this.showDialog.split(".", 2)
        return value[position]
      }

      return false
    },
    isShow() {
      this.showDialog = false
    },
    saveCover(imgShow, img, imgKey) {
      if (!imgKey || this.cover.key !== imgKey) {
        const vm = this
        axios
          .get(`${process.env.HOST}/api/uploads/image`, {
            params: {
              imageType: img.type,
              imageName: `articlecover${Date.now()}`,
              featureName: "article",
            },
          })
          .then((res) => {
            axios.put(res.data.url, img, {
              headers: { "content-type": img.type },
            })

            vm.$emit("cover", {
              file: img,
              key: res.data.imageKey,
              url: imgShow,
            })
          })
          .catch((e) => {
            throw e.message
          })
      }
    },
    setEdit() {
      this.$emit("edited", this.settings)
    },
    // Setting edits a local clone (vue/no-mutating-props); its "save" payload
    // must be forwarded or uploads are silently dropped (RJ-1691).
    saveSetting(setting) {
      this.$emit("edited", setting)
    },
    async validate() {
      const result = await this.$validator.validate()
      this.$emit("validate", result)
      return result
    },
    handleClickUploadThumbnailButton() {
      this.uploadThumbnailDialog.isShow = true
    },
    handleCancelUploadThumbnailDialog() {
      this.uploadThumbnailDialog.isShow = false
    },
    handleConfirmUploadThumbnailDialog(file) {
      this.uploadThumbnailDialog.isShow = false

      if (!file) {
        return
      }

      this.$emit("changeThumbnail", file)
    },
    isDisabledClass(editValue) {
      const disableClass = editValue
        ? {
            "disable-content": !this.isThaiLanguage,
            edit: editValue,
          }
        : {
            "disable-content": !this.isThaiLanguage,
          }

      return disableClass
    },
  },
}
</script>

<style lang="scss" scoped>
.disable-content {
  pointer-events: none;
  opacity: 0.5;
}
</style>
